import { render, staticRenderFns } from "./TerminationFormPage.vue?vue&type=template&id=f0f27296&"
import script from "./TerminationFormPage.vue?vue&type=script&lang=js&"
export * from "./TerminationFormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports